;(function () {

"use strict";

var DropdownPaneView = Backbone.View.extend({
  initialize: function () {
    this.$mask = this.$el.find('.mask');

    this.guid = window.App.guid();
    $(window).on('resize.'+this.guid, _.debounce(_.bind(this.resize, this)));

    this.resize();
    this.$el.removeClass('inactive');

    $(window).load(_.bind(function () {
      this.resize();
      this.$el.removeClass('inactive');
    }, this));
  },
  resize: function () {
    var w = $('body').width();
    var l = this.$el.offset().left;
    this.zoom = parseFloat($('html').css('zoom')) || 1;

    // if (window.DEBUG) {
      var maxCartHeight = ( $(window).height() / parseFloat(this.zoom) ) - $('header.site-header').height() - 40;

      if (maxCartHeight < 300) {
        maxCartHeight = '';
      }

      // console.log(maxCartHeight);
      this.$el.find('.cart .left').css('max-height', maxCartHeight);
    // }

    this.h = this.$mask.children().outerHeight();

    this.$mask.css({ left: -l, width: w });
  },
  mouseenter: function () {
    if ($('header .mobile').is(':visible')) {
      return;      
    }

    if (this.$el.hasClass('empty')) { return; }

    _.defer(_.bind(function () {
      this.$el.siblings().addClass('blocked');
      $('body').addClass('overlay');
      this.$mask.height(this.h);

      $('body').on('click.'+this.guid, _.bind(this.detectExit, this));
    }, this));
  },
  detectExit: function (e) {
    var el = e.target;

    if ($.contains(this.el, el) && (el != this.el)) {
      return;
    }

    this.mouseleave();
  },
  mouseleave: function () {
    this.$el.removeClass('hover');

    if ($('header .mobile').is(':visible')) {
      return;      
    }

    if (this.$el.hasClass('empty')) { return; }

    $('body').off('click.'+this.guid);

    this.$el.siblings().removeClass('blocked');
    $('body').removeClass('overlay');
    this.$mask.height(0);
  },
  events: {
    'mouseenter': 'mouseenter',
    'touchstart': 'mouseenter',
    'mouseleave': 'mouseleave'
  }
});

var SearchFormView = Backbone.View.extend({
  // initialize: function () {
  //   this.client = algoliasearch('808GQH9HV4', '18d27a98c6c38e9629a162b57cd5de4a');
  //   this.index = this.client.initIndex('shopify_products');
  //   this.$input = this.$el.find('input');
  // },
  // query: function () {
  //   var val = this.$('input').val();

  //   if (val.length <= 1) {
  //     return;
  //   }

  //   this.index.search({
  //     query: val,
  //     attributesToRetrieve: ['title', 'vendor'],
  //     hitsPerPage: 1
  //   }, function searchDone(err, content) {
  //       if (err) throw err;

  //       console.log(content.hits);
  //     }
  //   );
  // },
  // keyup: function () {
    // this.query();
  // },
  focus: function () {
    if ($('header .mobile').is(':visible')) {
      return;      
    }

    _.defer(_.bind(function () {
      this.$el.find('input').focus();
    }, this));
  },
  blur: function () {
    if ($('header .mobile').is(':visible')) {
      return;      
    }

    this.$el.find('input').blur();
  },
  events: {
    'mouseenter': 'focus',
    'mouseleave': 'blur',
    // 'keyup': 'keyup'
  }
});

var HeaderView = Backbone.View.extend({
  initialize: function () {
    // console.log('init header');

    window.App.dvs = {};
    this.$el.find(".misc .drop").each(function () {
      var key = $(this).attr('class').split(' ').pop();
      window.App.dvs[key] = new DropdownPaneView({ el: this });
    });

    this.guid = window.App.guid();
    /* Resize Logic */
    $(window).on('resize.'+this.guid, _.debounce(_.bind(this.resize, this)));
    /* Let fonts load, then resize */
    $(window).on('load', function () { $(window).trigger('resize'); });

    this.resize();

    new SearchFormView({ el: this.$el.find('.drop.search') });
  },
  resize: function () {
    var $dropdowns = this.$el.find('.dropdown');
    var zoom = $('html').css('zoom') || 1;
    zoom = parseFloat(zoom);

    var $wrapper = $('.site-header > .wrapper');
    var maxLeft = $wrapper.offset().left + parseInt($wrapper.css('padding-left'));

    $dropdowns.each(function () {
      var $nav = $(this).find('.dropdown-nav');
      if (!$nav[0]) { return; }

      var $arrow = $nav.find('.arrow');
      var tw = $nav.width();

      $nav.css({
        'margin-left': -tw/2
      });

      $arrow.css({
        'left': tw/2
      });

      var left = $nav.offset().left;
      if (left < maxLeft) {
        var diff = maxLeft - left;

        $nav.css({
          'margin-left': -tw/2 + diff
        });

        $arrow.css({
          'left':  tw/2 - diff
        });
      }
    });
  },
  toggle: function (e) {
    var $this = $(e.currentTarget);

    if ($this.hasClass('active')) {
      this.$el.find('.active').removeClass('active');
      return;
    }

    this.$el.find('.active').removeClass('active');
    this.$el.find('.'+$this.attr('class')).toggleClass('active');
  },
  events: {
    'click ul.mobile.left > li': 'toggle',
    'click strong.title': function (e) {
      var $parent = $(e.currentTarget).closest('ul').parent();
      var isActive =  $parent.hasClass('active');
      $parent.siblings().removeClass('active');

      if (!isActive) {
        $parent.addClass('active');
      } else {
        $parent.removeClass('active');
      }
    }
  }
});

module.exports = HeaderView;

}());